define("calendar/engine", ["exports", "ember-engines/engine", "ember-load-initializers", "calendar/config/environment", "calendar/resolver"], function (_exports, _engine, _emberLoadInitializers, _environment, _resolver) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/engine",0,"ember-load-initializers",0,"calendar/config/environment",0,"calendar/resolver"eaimeta@70e063a35619d71f
  const {
    modulePrefix
  } = _environment.default;
  const Eng = _engine.default.extend({
    modulePrefix,
    Resolver: _resolver.default,
    dependencies: {
      services: ['alerts', 'auth', 'cache', 'creator-cohort', 'calendar/bttp', 'calendar/config', 'calendar/events', 'calendar/markup', 'credential-status', 'dialog-manager', 'errors', 'events', 'instagram', 'intl', 'laterConfig', 'local-storage-manager', 'locale', 'media-labels', 'media-library', 'media-navigation', 'onboarding-wizard-manager', 'onboarding', 'perfect-scroll', 'performance-tracking', 'plans', 'post-navigation', 'progress-bar', 'router', 'schedule', 'schedule/calendar/time-slot', 'schedule/caption-hashtags', 'schedule/post', 'schedule/posts-pending-approval', 'seamless-checkout-manager', 'secondary-modal', 'segment-events', 'segment', 'selected-social-profiles', 'snapchat', 'social/connect-profiles', 'social/instagram-audio', 'social/instagram-auth', 'social/instagram-business', 'store', 'subscriptions', 'tiktok', 'user-agent', 'user-config', 'user-role', 'social-listening/future-insights'],
      externalRoutes: ['cluster.media.edit', 'cluster.social-listening.future-insights.overview']
    }
  });
  (0, _emberLoadInitializers.default)(Eng, modulePrefix);
  var _default = _exports.default = Eng;
});